import {MutationOptions, useMutation} from 'react-query';
import { UsernameEnquiryData } from '../@types';
import { APIError, APIResponse, API_URL, post } from '../api';

function useUsernameEnquiry(
  options?: MutationOptions<
    APIResponse<UsernameEnquiryData>,
    APIError,
    {username: string}
  >,
) {
  const {
    isLoading: fetchingUsername,
    isError: isEnquiryError,
    data: usernameEnquiryData,
    error: enquiryError,
    mutate: checkUsername,
  } = useMutation<
    APIResponse<UsernameEnquiryData>,
    APIError,
    {username: string}
  >(
    async (variables: {username: string}) =>
      await post(
        API_URL + '/account/wallet/transfer/get-recipient-name',
        variables,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        },
      ),
    options,
  );

  return {
    fetchingUsername,
    enquiryError,
    isEnquiryError,
    checkUsername,
    usernameEnquiryData,
  };
}

export default useUsernameEnquiry;